import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { CartAtom } from '../../atoms/accountAtom'; // 경로 수정
import { useAuth } from "../../authContext";


// 스타일 컴포넌트
const Container = styled.div`
 max-width: 1200px;
 margin: 0 auto;
 padding: 20px;
 display: flex;
 gap: 24px;
`;

const MainContent = styled.div`
 flex: 1;
`;

const Grid = styled.div`
 display: grid;
 grid-template-columns: repeat(4, 1fr);
 gap: 24px;

 @media (max-width: 1200px) {
   grid-template-columns: repeat(3, 1fr);
 }

 @media (max-width: 900px) {
   grid-template-columns: repeat(2, 1fr);
 }

 @media (max-width: 600px) {
   grid-template-columns: repeat(1, 1fr);
 }
`;

const Card = styled.div`
 background: white;
 border-radius: 8px;
 overflow: hidden;
 box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
 transition: transform 0.2s, box-shadow 0.2s;
 
 &:hover {
   transform: translateY(-5px);
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
 }
`;

const CardImage = styled.div`
 width: 100%;
 height: 200px;
 background: #f1f1f1;
 display: flex;
 align-items: center;
 justify-content: center;
`;

const CardContent = styled.div`
 padding: 16px;
`;

const Title = styled.h3`
 font-size: 16px;
 margin: 0 0 8px 0;
 color: #111827;
`;

const Price = styled.p`
 font-size: 14px;
 margin: 0 0 16px 0;
 color: #111827;
`;

const ButtonGroup = styled.div`
 display: flex;
 gap: 8px;
`;

const Button = styled.button`
 flex: 1;
 padding: 8px 16px;
 border-radius: 4px;
 border: none;
 font-size: 12px;
 cursor: pointer;
 
 ${props => props.primary ? `
   background: #111827;
   color: white;
 ` : `
   background: #f3f4f6;
   color: #111827;
 `}
`;

const Sidebar = styled.div`
 width: 300px;
`;

const SidebarCard = styled.div`
 background: white;
 border-radius: 8px;
 padding: 16px;
 box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
 margin-bottom: 16px;
`;

const SidebarTitle = styled.h2`
 font-size: 16px;
 margin: 0 0 16px 0;
 color: #111827;
`;

const CheckoutButton = styled(Button)`
 width: 100%;
 background: #111827;
 color: white;
`;

const CartItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

const CartQuantity = styled.div`
 display: flex;
 align-items: center;
 gap: 8px;
`;

const DeleteButton = styled.button`
 background: none;
 border: none;
 color: #ef4444;
 cursor: pointer;
 padding: 4px;
 font-size: 14px;
`;

const TabContainer = styled.div`
 display: flex;
 gap: 10px;
 margin-bottom: 20px;
 flex-wrap: wrap;
`;

const Tab = styled.button`
 padding: 8px 16px;
 border-radius: 20px;
 border: none;
 background: ${props => props.active ? '#00ADB5' : '#f5f5f5'};
 color: ${props => props.active ? 'white' : '#333'};
 cursor: pointer;
 font-weight: 500;
 
 &:hover {
   background: ${props => props.active ? '#00ADB5' : '#e5e5e5'};
 }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: #666;
`;

const TypeTitle = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  color: #111827;
`;
const Input = styled.input`
  width: calc(100% - 1.75rem);
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.575rem;
  
  &:focus {
    outline: none;
    border-color: #94a3b8;
    box-shadow: 0 0 0 1px #94a3b8;
  }
`
// 코스 카드 컴포넌트 수정
const CourseCard = ({ product, onAddToCart }) => {
  const navigate = useNavigate();
  const { prod_id, prod_name, prod_price, image_url } = product;
  
  // 카드 클릭 시 상세 페이지로 이동하는 함수 추가
  const goToDetail = () => {
      navigate(`/CourseDetail/${prod_id}`, { state: { product } });
  };
  
  const purchase = (item) => {
      var ItemListArray = [item];
      onAddToCart(ItemListArray);
      navigate('/Product', { state: [item] });
  }

  const handleAddToCart = (newItem) => {
      const numericPrice = parseInt(newItem.price);
      onAddToCart((currentCart) => {
          // 이미 장바구니에 있는지 확인
          const existingItemIndex = currentCart.findIndex(item => item.id === newItem.id);
          
          if (existingItemIndex >= 0) {
              // 이미 있으면 수량 증가
              const updatedCart = [...currentCart];
              updatedCart[existingItemIndex] = {
                  ...updatedCart[existingItemIndex],
                  price: numericPrice,
                  quantity: updatedCart[existingItemIndex].quantity + 1
              };
              return updatedCart;
          } else {
              // 없으면 새로 추가
              return [...currentCart, { 
                  ...newItem, 
                  price: numericPrice, 
                  quantity: 1,
                  category: '강의',
                  image: image_url || "https://placehold.co/400x300/f0f0f0/888888?text=상품+이미지"
              }];
          }
      });
  };

  return (
      <Card onClick={goToDetail} style={{ cursor: 'pointer' }}>
          <CardImage>
              <img src={image_url} alt={prod_name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </CardImage>
          <CardContent>
              <Title>{prod_name}</Title>
              <Price>가격: {Number(prod_price).toLocaleString()}원</Price>
              <ButtonGroup>
                  <Button 
                      onClick={(e) => {
                          e.stopPropagation(); // 버튼 클릭 시 카드 클릭 이벤트 방지
                          handleAddToCart({ title: prod_name, price: prod_price, id: prod_id });
                      }}
                  >
                      장바구니
                  </Button>
                  <Button 
                      primary 
                      onClick={(e) => {
                          e.stopPropagation(); // 버튼 클릭 시 카드 클릭 이벤트 방지
                          purchase({ title: prod_name, price: prod_price, id: prod_id });
                      }}
                  >
                      구매하기
                  </Button>
              </ButtonGroup>
          </CardContent>
      </Card>
  );
};
// 메인 CourseLibrary 컴포넌트
export default function CourseLibrary() {
   const { type } = useParams(); // URL에서 타입 파라미터 가져오기
   const [cartItems, setCartItems] = useRecoilState(CartAtom); // CartAtom 사용
   const [products, setProducts] = useState([]);
   const [categories, setCategories] = useState([]);
   const [activeCategory, setActiveCategory] = useState('ALL');
   const [typeInfo, setTypeInfo] = useState(null);
   const [hoverItemIndex, setHoverItemIndex] = useState(-1);
   const [isLoading, setIsLoading] = useState(true);
   const { login, user } = useAuth();
   const navigate = useNavigate();

// CourseLibrary 컴포넌트 내부
useEffect(() => {
  // type이 변경될 때 상태 초기화
  setProducts([]);
  setActiveCategory('ALL');
  setIsLoading(true);
  
  const fetchTypeInfo = async () => {
    try {
      const response = await fetch(`/api/getTypeInfo?type_id=${type}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setTypeInfo(data);
    } catch (error) {
      console.error('타입 정보 조회 실패:', error);
    }
  };
  
  if (type) {
    fetchTypeInfo();
  }
}, [type]); // 의존성 배열에 type을 포함해야 합니다
     
     // 타입에 따른 카테고리 목록 조회
     useEffect(() => {
       const fetchCategories = async () => {
         try {
           setIsLoading(true);
           const response = await fetch(`/api/getCategories?type_id=${type}`);
           if (!response.ok) {
             throw new Error(`HTTP error! status: ${response.status}`);
           }
           const data = await response.json();
           
           if (data && data.length > 0) {
             setCategories(data);
             // 첫 번째 카테고리를 기본값으로 설정
           } else {
             setCategories([]);
             setActiveCategory('');
           }
         } catch (error) {
           console.error('카테고리 목록 조회 실패:', error);
           setCategories([]);
         } finally {
           setIsLoading(false);
         }
       };
       
       if (type) {
         fetchCategories();
       }
     }, [type]);
     
     // 선택된 카테고리에 따른 상품 목록 조회
     useEffect(() => {
       const fetchProducts = async () => {
         if (!activeCategory) return;
         
         setIsLoading(true);
         try {
           const response = await fetch('/api/getProductsByCategory', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
             },
             body: JSON.stringify({ type_id: type ,category_name:activeCategory}),
           });
           
           if (!response.ok) {
             throw new Error(`HTTP error! status: ${response.status}`);
           }
           
           const data = await response.json();
           setProducts(data);
         } catch (error) {
           console.error('상품 목록 조회 실패:', error);
           setProducts([]);
         } finally {
           setIsLoading(false);
         }
       };
       
       fetchProducts();
     }, [activeCategory, type]);

   const updateQuantity = (itemToUpdate, delta) => {
       setCartItems((items) =>
         items.map((item) => {
           if (item.id === itemToUpdate.id) {
             const newQuantity = Math.max(1, item.quantity + delta);
             return { ...item, quantity: newQuantity };
           }
           return item;
         })
       );
   };

   const getTotalPrice = () => {
       return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
   };

   const deleteItem = (itemToDelete) => {
       setCartItems((items) => items.filter(item => item.id !== itemToDelete.id));
   };

   return (
       <Container>
           <MainContent>
               {typeInfo && <TypeTitle>{typeInfo.type_name} 강의</TypeTitle>}
               
               <TabContainer>
                    <Tab 
                        key={0}
                        active={activeCategory === 'ALL'} 
                        onClick={() => setActiveCategory('ALL')}
                    >
                        ALL
                    </Tab>
                   {categories.map(category => (
                       <Tab 
                           key={category.category_id}
                           active={activeCategory === category.category_name} 
                           onClick={() => setActiveCategory(category.category_name)}
                       >
                           {category.category_name}
                       </Tab>
                   ))}
               </TabContainer>

               {isLoading ? (
                   <LoadingContainer>
                       강의를 불러오는 중입니다...
                   </LoadingContainer>
               ) : products.length === 0 ? (
                   <LoadingContainer>
                       해당 카테고리에 강의가 없습니다.
                   </LoadingContainer>
               ) : (
                   <Grid>
                       {products.map((product, idx) => (
                           <CourseCard 
                               key={idx}
                               product={product}
                               onAddToCart={setCartItems}
                           />
                       ))}
                   </Grid>
               )}
           </MainContent>
           
           <Sidebar>
               <SidebarCard>
                   <SidebarTitle>내 상품 리스트</SidebarTitle>
                   <div>장바구니</div>
                   <div style={{height:'auto'}} className="item-container">
                   {cartItems.map((item, idx) => (
                       <CartItemContainer
                           key={idx}
                           onMouseEnter={() => setHoverItemIndex(idx)}
                           onMouseLeave={() => setHoverItemIndex(-1)}
                       >
                           <span>{item.title}</span>
                           <CartQuantity>
                               <button onClick={() => updateQuantity(item, -1)}>-</button>
                               {item.quantity}
                               <button onClick={() => updateQuantity(item, 1)}>+</button>
                           </CartQuantity>
                           <span>{(item.price * item.quantity).toLocaleString()}원</span>
                           {hoverItemIndex === idx && (
                               <DeleteButton onClick={() => deleteItem(item)}>X</DeleteButton>
                           )}
                       </CartItemContainer>
                   ))}
                   </div>
                   <div style={{marginBottom: '12px'}}>
                       Total: {getTotalPrice().toLocaleString()}원
                   </div>
                   <CheckoutButton onClick={() => navigate('/Product', {state: cartItems})}>
                       결제하기
                   </CheckoutButton>
               </SidebarCard>

               {user && (
                   <SidebarCard>
                       <SidebarTitle>앤츠코인 충전하기</SidebarTitle>
                       <div className="flex justify-between items-center mb-4">
                           <span className="text-gray-700">앤츠코인</span>
                           <span>0 원</span>
                       </div>
                       <div className="mb-4">
                           <label htmlFor="amount">금액입력</label>
                           <Input 
                               type="text" 
                               placeholder="금액을 입력하세요"
                           />
                       </div>
                       <CheckoutButton>충전하기</CheckoutButton>
                   </SidebarCard>
               )}
           </Sidebar>
       </Container>
   );
}